import PrimaryButton from "../../../../../components/common/PrimaryButton";
import { useTranslation } from "react-i18next";
import {
  ETrasactionsType,
  IContractDetailsResponseData,
} from "../../../../../setup/api/services/contract/models";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../../../../setup/constants";
import { EPARTY_STATUS } from "../../../../../enums";

interface ItemAcceptedActionsProps {
  milestone: IContractDetailsResponseData;
}

const ItemAcceptedActions = ({ milestone }: ItemAcceptedActionsProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleSettlementButton = () => {
    navigate(ROUTES.SETTLEMENT_DETAILS.replace(":id", milestone.id));
  };

  if (
    !milestone?.cashOutAmountList === null ||
    milestone?.transactions?.some(
      (transaction) => transaction.type === ETrasactionsType.CASH_OUT
    ) ||
    milestone.parties?.some((party) => party.userId === null) ||
    milestone.parties?.some(
      (party) => party.status === EPARTY_STATUS.INVITED
    ) ||
    milestone.parties?.some(
      (party) => party.status === EPARTY_STATUS.REJECTED_INVITE
    )
  ) {
    return null;
  }

  return (
    <>
      <PrimaryButton
        onClick={handleSettlementButton}
        style={{
          width: "171px",
          height: "40px",
          borderRadius: "8px",
          textAlign: "center",
          whiteSpace: "nowrap",
          fontSize: "14px",
          lineHeight: "100%",
          fontWeight: 500,
          background: "#0D44AD",
        }}>
        {t("global_status_settlement")}
      </PrimaryButton>
    </>
  );
};

export default ItemAcceptedActions;
